import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AppWrapper from '../shared/appWrapper';
import { FetchCities } from '../../actions/cities';
import { SetBuilderCity, AddBuilderItem, RemoveBuilderItem, AddSequences, ClearBuilderList } from '../../actions/builder';
import { FetchCyoaProducts } from '../../actions/products';
import _filter from 'lodash/filter';
import _forEach from 'lodash/forEach';
import _orderBy from 'lodash/orderBy';
import _unionBy from 'lodash/unionBy';
import Spinner from '../shared/spinner';
import { builderListData } from '../../helpers/builderHelper';
import ReactModal from 'react-modal';
import Fuse from 'fuse.js';
import { getCyoaID, getCyoaName } from '../../helpers/cyoaHelper';

import BuilderCard from './components/builder-card';
import DestinationPanel from './components/destination-panel';

const queryString = require('query-string');
const parsed = queryString.parse(window.location.search);


ReactModal.setAppElement('#root');

class Builder extends PureComponent {

  constructor(props){
    super(props);
   
    this.state = {
      mapIsOpen:false,
      promptIsOpen:false,
      ready:{
        city:false,
        product:false
      },
      searchIsOpen:false,
      cities:[],
      originalSearchList:[],
      searchList:[],
      searchInputValue:"",
      searchDropdownNumber:-1,
      searchReady:false
    }

    this.fuse = null;

    this.onConfirm = this.onConfirm.bind(this);
    this.onCloseClicked = this.onCloseClicked.bind(this);
    this.openMapModal = this.openMapModal.bind(this);
    this.closeMapModal = this.closeMapModal.bind(this);
    this.searchbarClicked = this.searchbarClicked.bind(this);
    this.documentClickHandler = this.documentClickHandler.bind(this);
    this.documentKeydownHandler = this.documentKeydownHandler.bind(this);
    this.cityClicked = this.cityClicked.bind(this);
    this.openPromptModal = this.openPromptModal.bind(this);
    this.closePromptModal = this.closePromptModal.bind(this);
    this.confirmPromptModal = this.confirmPromptModal.bind(this);
    this.onBackClicked = this.onBackClicked.bind(this);
  }

  openMapModal(){ this.setState({mapIsOpen:true}); }
  closeMapModal(){ this.setState({mapIsOpen:false}); }
  openPromptModal(){ this.setState({promptIsOpen:true}); }
  closePromptModal(){ this.setState({promptIsOpen:false}); }

  documentKeydownHandler(e){

    const { searchIsOpen, searchDropdownNumber } = this.state;
    const searchInput = document.querySelectorAll('.builder-search-wrapper .builder-search-results ul li');
    const searchActive = document.querySelector('.builder-search-wrapper .builder-search-results ul li[data-index="'+searchDropdownNumber+'"]');


    if(searchIsOpen){

      //Increment/Decrement cursor position
      if(e.key === 'ArrowDown' && searchDropdownNumber < searchInput.length - 1){
        this.setState({searchDropdownNumber:searchDropdownNumber + 1});
      }
      else if(e.key === 'ArrowUp' && searchDropdownNumber > 0){
        this.setState({searchDropdownNumber:searchDropdownNumber - 1});
      }
      else if(e.key === 'Enter' && searchActive !== null){
        this.cityClicked(searchActive.dataset.name);
      }
    }
  }

  searchbarClicked(){
    if(this.props.builderlist.length === 0 )this.setState({searchIsOpen: !this.state.searchIsOpen})
  }

  confirmPromptModal(){
    this.props.ClearBuilderList();
    this.closePromptModal();
  }

  componentDidMount(){


    //Change document title
    document.title = "Create your own adventure - Builder";


   //listeners
   document.body.addEventListener('click', this.documentClickHandler);

  }

  componentWillUnmount(){
    document.body.removeEventListener('click', this.documentClickHandler);
    this.fuse = null;
  }

  documentClickHandler(e){
    try{
      if(e.target.offsetParent.className !== "builder-search-results"){
        this.setState({searchIsOpen:false});
      }
    }catch(e){}
  }

  cityClicked(city){

    const { ready } = this.state;
    const {
      cities,
      cyoaProducts,
      SetBuilderCity,
      AddBuilderItem
     } = this.props;


    if(ready.product && ready.city){

      this.setState({searchIsOpen:false, searchInputValue:""});

      const isCityValid = _filter(cities, ['name', city])[0];
      const isProductValid = _filter(cyoaProducts, ['name', city])[0];

      if(isCityValid !== undefined && Object.keys(isCityValid).length > 0){
        SetBuilderCity(city);
        AddBuilderItem(builderListData('sector', isCityValid), null);
      }
      else if(isProductValid !== undefined && Object.keys(isProductValid).length > 0){
        SetBuilderCity(city);
        AddBuilderItem(builderListData('sector', isProductValid), null);
      }
    }


  }

  componentDidUpdate(prevProps, prevState){

    const {
      currency,
      currency:{iso_currency_code},
      FetchCities, cities,
      FetchCyoaProducts,
      cyoaProducts
     } = this.props;

     const { searchDropdownNumber } = this.state;

     if(searchDropdownNumber !== prevState.searchDropdownNumber){
       const searchInputContainer = document.querySelector('.builder-search-wrapper .builder-search-results');
       const searchInput = document.querySelectorAll('.builder-search-wrapper .builder-search-results ul li');
       const searchActive = document.querySelector('.builder-search-wrapper .builder-search-results ul li[data-index="'+searchDropdownNumber+'"]');

       for(let i = 0; i < searchInput.length; i++){
         searchInput[i].classList.remove('hover');
       }

       //hover state
       searchActive.classList.add('hover');

       //scroll container
       searchInputContainer.scrollTop = searchActive.offsetTop;

     }

     if(currency !== prevProps.currency){
        FetchCities(iso_currency_code, getCyoaID());
        FetchCyoaProducts(iso_currency_code, getCyoaID());
     }

     if(cities !== prevProps.cities){

        //Save all cities and popular cities
        let citiesArr = [];
        let popularArr = [];

        const citiesSorted =  _orderBy(cities, ['city', 'asc']);
        const popularSorted = _orderBy(cities, ['popularity', 'asc']);

        popularArr.push({name:'Top destinations', type:'title'});
        citiesArr.push({name:'All destinations', type:'title'});

        _forEach(citiesSorted, (o) => {citiesArr.push({name:o.city, type:"city"})});
        _forEach(popularSorted, (o, i) => { if(i < 10) popularArr.push({name:o.city, type:"popular"})});

        const originalSearchList = _unionBy(popularArr, citiesArr);
        const searchList = citiesSorted.map(o => { return {name:o.city, type:"city"} });

        // this.setState({cities:_unionBy(popularArr, citiesArr)});

        this.setState({originalSearchList:parsed.destination === "usa" ? searchList : originalSearchList, searchList: searchList});


        //initialise fuse fuzzy search
        this.fuse = new Fuse(originalSearchList, {
          shouldSort: true,
          tokenize: true,
          matchAllTokens: true,
          findAllMatches: true,
          threshold: 0.3,
          location: 0,
          distance: 10,
          maxPatternLength: 32,
          minMatchCharLength: 3,
          keys: ["name"]
       });


      //Cities ready
      this.setState(prevState => ({ ready: {...prevState.ready, city: true} }))
     }

     if(cyoaProducts !== prevProps.cyoaProducts){

      //Products ready
      this.setState(prevState => ({ ready: {...prevState.ready, product: true} }))
     }



  }


  onCloseClicked(index){

    const {
      RemoveBuilderItem,
      builderlist,
    } = this.props;

    //Check if builder list has a product and greater than 2 items
    let productNumber = _filter(builderlist, ['type', 'product']).length;
    let hasProduct = (productNumber > 0 && builderlist.length > 3 && builderlist[index].type === "sector" ) ? true : false;

    RemoveBuilderItem(index, builderlist[index-1].next, hasProduct, productNumber);

  }


  onConfirm(){

    const {
      currency:{iso_currency_code},
      reservations,
      AddSequences,
      builderlist
     } = this.props;

    AddSequences(iso_currency_code, reservations, builderlist, getCyoaID()).then((data)=>{
      const destination = (parsed.destination !== undefined ? `&destination=${parsed.destination}` : "");
      window.location.href = `${process.env.REACT_APP_WWW_DISCOVERY_URL}${process.env.REACT_APP_PREVIEW_PAGE}?guid=${data.data[0].sequence_id}${destination}`;
    });

  }

  searchHandleChange(e){
    this.setState({searchInputValue:e.target.value});
    this.search(e.target.value);
  }


  renderSearchResultItems(arr, pattern){

    const { originalSearchList } = this.state;

    let searchResultOriginal = [];
    let searchResultItems = [];
    let count = -1;

    //create modify search list
    for (let i = 0; i < arr.length; i++){
      if(arr[i].type !== 'popular' && arr[i].type !== 'title'){
        count++;
        searchResultItems.push(
          <li key={ `${arr[i].name}${Math.random()}` } data-index={count} data-test="test" data-name={arr[i].name} className={`${arr[i].type}`} onClick={ (e)=>{ this.cityClicked(arr[i].name) } }>
            <span>{arr[i].name}</span>
          </li>
        )
      }
    }

    for (let j = 0; j < originalSearchList.length; j++){
      searchResultOriginal.push(
        <li key={ `${originalSearchList[j].name}${Math.random()}` } data-index={j} data-name={originalSearchList[j].name} className={`${originalSearchList[j].type}`} onClick={ (e)=>{ this.cityClicked(originalSearchList[j].name) } }>
          <span>{originalSearchList[j].name}</span>
        </li>
      )
    }


  return (pattern === "") ? searchResultOriginal : searchResultItems;

}

  search(pattern){

    const { ready, originalSearchList } = this.state;

    if(ready.product && ready.city){
      const _searchPattern = (pattern === "") ? originalSearchList : this.fuse.search(pattern);
      return <ul id="search-result-list">{this.renderSearchResultItems(_searchPattern, pattern)}</ul>
    }else{
      return <p className="loading-text">Loading...</p>
    }
  }

  renderSearchPlaceholder(){

    const {
      builderlist
    } = this.props;

    if(builderlist.length === 0){
      return 'Select your start destination';
    }
    if(builderlist.length !== 0){
      return  (builderlist.length > 0 && builderlist[0].name !== undefined) ? 'Trip starting from ' + builderlist[0].name : "";
    }
  }

  onBackClicked(){
    this.props.history.goBack();
  }

  render(){

    const { searchIsOpen, ready, mapIsOpen, promptIsOpen, searchInputValue } = this.state;
    const { builderlist, builderSequence: {isFetching}, reservations } = this.props

    if(!ready.product && !ready.city){
      return <Spinner text="Loading trip wizard..." loadClass="orange-spinner-wrapper"/>
    }else{

      return (
        <AppWrapper navbar={false} back={false} skip={false} text="Builder" onBackClick={null}>
        <button className="lity-close lity-back" onClick={this.onBackClicked}><i className="arrow left"></i></button>
        <button className="lity-close" onClick={this.onBackClicked}>×</button>
        <div className="builder text-center">
          <div className="row margin-t-50">
            <div className="column small-12">
              <h4>Create Your <span className="bold">Own Adventure</span></h4>
               <p className="no-margin">Make Your Own Way by selecting the cities from our <a className="orange-text hoho-text" href={`${getCyoaName() === "usa" ? "https://www.busabout.com/usa/hop-on-hop-off" : "https://www.busabout.com/hop-on-hop-off-europe" }`} target="_blank" rel="noopener noreferrer">
                  Hop-On Hop-Off Coach Network</a> <br /> and adding Adventures, Festivals or Sailing Trips</p>
            </div>



            <div className="columns small-12 medium-10 large-6 medium-offset-1 large-offset-3 end">
              <div className="builder-search-wrapper">
                <div className="builder-search-bar" onClick={this.searchbarClicked}>

                  <svg xmlns="http://www.w3.org/2000/svg" className="city-svg" width="60.3379" height="76.0089" viewBox="0 0 60.3379 76.0089">
                  <g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M30.1689,43.39A16.5073,16.5073,0,1,1,46.6758,26.8829,16.5263,16.5263,0,0,1,30.1689,43.39Zm0-29.0146A12.5073,12.5073,0,1,0,42.6758,26.8829,12.522,12.522,0,0,0,30.1689,14.3755Z"/><path d="M30.1689,36.1363a9.2534,9.2534,0,1,1,9.2529-9.2534A9.2641,9.2641,0,0,1,30.1689,36.1363Zm0-14.5068a5.2534,5.2534,0,1,0,5.2529,5.2534A5.2592,5.2592,0,0,0,30.1689,21.6295Z"/><path d="M40.6738,65.1212a2,2,0,0,1-1.6182-3.1729c3.7217-5.14,13.7432-19.4116,15.3965-23.67a24.1429,24.1429,0,0,0,1.8857-8.5c0-7.624-2.7061-14.4121-7.6182-19.1133A24.7721,24.7721,0,0,0,30.2568,4.0279q-.0879.0044-.1758,0a24.7635,24.7635,0,0,0-18.4629,6.6367C6.7061,15.3658,4,22.1539,4,29.7779a22.3385,22.3385,0,0,0,1.3877,7.1436C6.95,41.4517,18.2266,56.483,22.4395,61.8922a2,2,0,0,1-3.1562,2.458C17.6914,62.3057,3.6689,44.2042,1.6064,38.2266A26.2575,26.2575,0,0,1,0,29.7779C0,21.0518,3.1445,13.2374,8.8535,7.775A28.733,28.733,0,0,1,30.1689.0279,28.76,28.76,0,0,1,51.4844,7.775c5.709,5.4624,8.8535,13.2769,8.8535,22.0029a28.018,28.018,0,0,1-2.1572,9.9473C56.0029,45.3345,42.8545,63.5225,42.2959,64.294A1.9972,1.9972,0,0,1,40.6738,65.1212Z"/><path d="M30.1689,76.0089a1.9935,1.9935,0,0,1-1.4141-.5859l-4.4521-4.4521a2,2,0,0,1,2.8281-2.8281L30.1689,71.18l3.0381-3.0376a2,2,0,0,1,2.8281,2.8281L31.583,75.4229A1.9935,1.9935,0,0,1,30.1689,76.0089Z"/></g></g></svg>


                  <input type="search" id="search-input" value={searchInputValue} placeholder={this.renderSearchPlaceholder()} onChange={ e => this.searchHandleChange(e) } onKeyDown={e => this.documentKeydownHandler(e)} className={`${builderlist.length !== 0 ? 'active' : ''}`} autoComplete="off" autoCorrect="off" />

                  <svg className="search" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" style={{display: builderlist.length === 0 ? 'block' : 'none'}}>
                    <path d="M19.862 18.812l-5.039-5.04a.464.464 0 0 0-.332-.136h-.402A8.123 8.123 0 0 0 8.124 0 8.123 8.123 0 0 0 0 8.125a8.123 8.123 0 0 0 13.636 5.968v.398c0 .125.05.243.137.332l5.039 5.04a.47.47 0 0 0 .664 0l.386-.387a.47.47 0 0 0 0-.664zM8.125 14.999A6.87 6.87 0 0 1 1.25 8.125 6.87 6.87 0 0 1 8.125 1.25a6.87 6.87 0 0 1 6.874 6.875 6.87 6.87 0 0 1-6.874 6.874z" fill="#8E8E8E" fillRule="nonzero"/>
                  </svg>

                  <svg className="close-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{display: builderlist.length !== 0 ? 'block' : 'none'}} onClick={this.openPromptModal}>
                    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 464c-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216zm94.8-285.3L281.5 256l69.3 69.3c4.7 4.7 4.7 12.3 0 17l-8.5 8.5c-4.7 4.7-12.3 4.7-17 0L256 281.5l-69.3 69.3c-4.7 4.7-12.3 4.7-17 0l-8.5-8.5c-4.7-4.7-4.7-12.3 0-17l69.3-69.3-69.3-69.3c-4.7-4.7-4.7-12.3 0-17l8.5-8.5c4.7-4.7 12.3-4.7 17 0l69.3 69.3 69.3-69.3c4.7-4.7 12.3-4.7 17 0l8.5 8.5c4.6 4.7 4.6 12.3 0 17z"/>
                  </svg>
                </div>

                <div className="builder-search-results" style={{display:searchIsOpen ? "block" : "none"}}>
                  { this.search(searchInputValue) }
                </div>

              </div>
            </div>
          </div>

          <div className="row margin-t-40">
            <div className="column small-12 medium-10 large-6 medium-offset-1 large-offset-3" style={{display:(builderlist.length === 0) ? "none" : "block" }}>
              <ul className="builder-list">
                {
                  builderlist.map((data, index) => {
                    return (
                      <li key={index} className={`builder-list-item builder-list-item-card ${(builderlist.length === index + 1 )? 'last': ''} ${getCyoaName()}`}>
                        <BuilderCard
                          id={'builder-view'}
                          showClose={true}
                          showPlus={false}
                          onCloseClicked={this.onCloseClicked}
                          sequence={data}
                          type={data.type}
                          index={index}
                        />
                      </li>
                    )
                  })
                }
                <li className="builder-list-item">
                  <DestinationPanel destination={getCyoaName()} />
                </li>
              </ul>

            </div>
          </div>

          <div className="row">

          <div className="column small-12 medium-8 large-6 medium-offset-2 large-offset-3">
              <div className="builder-continue">
                <button
                  type="submit"
                  className={`busabout--cta orange builder-submit-button ${(reservations.length >  1) ? '': 'disabled'}` }
                  disabled={ (reservations.length >  1) ? false : true}
                  onClick={this.onConfirm}>
                  <span style={{display:!isFetching ? "block" : "none"}}>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"/></svg>
                  Confirm &amp; Continue
                  </span>
                  <span style={{display:isFetching ? "block" : "none"}}><span className="fa fa-spinner fa-lg fa-spin"></span></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="network-map">
          <a onClick={this.openMapModal}>
            <img alt="Coach Network 2019 Map"
                  data-src={`${getCyoaName() === "usa" ? "https://images.ctfassets.net/3ng3kfj0qs70/7tRwqkVYFuz7c4F3HDHryG/8c1d3ce26fa6908decad744cfc52a486/usa-hoho.gif?w=800" : "https://images.ctfassets.net/3ng3kfj0qs70/5s70tYJpSMYKOQgEMYYQ8A/dc3dac3e42b4e14ecbfe508e96b46608/hoho-map.gif?w=600"}`}
                  className="lazyload" />
          </a>
        </div>

        <ReactModal
          className="map-modal"
          overlayClassName="modal-overlay semi-white scroll"
          isOpen={mapIsOpen}
          onRequestClose={this.closeMapModal}
          contentLabel="Share modal">
           <div className="map-modal-container">
              <div className="row">
                <div className="column small-12">
                  <img alt="Coach Network 2019 Map"
                data-src={`${getCyoaName() === "usa" ? "https://images.ctfassets.net/3ng3kfj0qs70/7tRwqkVYFuz7c4F3HDHryG/8c1d3ce26fa6908decad744cfc52a486/usa-hoho.gif?w=800" : "https://images.ctfassets.net/3ng3kfj0qs70/5s70tYJpSMYKOQgEMYYQ8A/dc3dac3e42b4e14ecbfe508e96b46608/hoho-map.gif?w=600"}`}
                className="lazyload" />
                </div>
              </div>

              <button className="close-button orange" onClick={this.closeMapModal}></button>
           </div>
        </ReactModal>


        <ReactModal
          className="error-modal builder-modal"
          overlayClassName="modal-overlay semi-white"
          isOpen={promptIsOpen}
          onRequestClose={this.closePromptModal}
          contentLabel="Edit Prompt modal">

          <div className="error-modal-container">
            <div className="row">
              <div className="column small-12">
                <div className="ba-icon ba_icon_extra_info_alt"></div>
                <p className="wait-text">Hey Wait!</p>
                <p>Are you sure you want to start again?</p>
              </div>
            </div>
            <div className="row">
              <div className="column small-12 text-center">
                <button type="button" className="busabout--cta orange back-search" onClick={this.confirmPromptModal}>
                  Confirm
                </button>
              </div>
            </div>
            <button className="modal-close orange" onClick={this.closePromptModal}>
              &#x2715;
            </button>
          </div>
        </ReactModal>

      </AppWrapper>
      )

    }
  }
}


function mapStateToProps(state){
  return{
    cities:state.cities.data,
    currency:state.currency,
    cyoaProducts:state.cyoaProducts.data,
    builderlist:state.builderlist.data,
    reservations:state.builderlist.reservations,
    builderSequence:state.builderSequence
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    FetchCities,
    FetchCyoaProducts,
    SetBuilderCity,
    AddBuilderItem,
    RemoveBuilderItem,
    AddSequences,
    ClearBuilderList
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Builder);



// WEBPACK FOOTER //
// ./src/components/builder/index.js